import React from "react";
import { logOut } from "../../store/auth/authActions";
import { useDispatch, useSelector } from "react-redux";
import { State } from "../../store";
import AccountData from "./AccountData";
import ChangePassword from "./ChangePassword";
import { setInfoMessage } from "../../store/alerts/alertsActions";

interface IProps {
  ticketsTabActive: number;
  setTicketsTabActive: (value: number) => void;
}

const AccountDataPanel: React.FC<IProps> = ({ ticketsTabActive, setTicketsTabActive }: IProps) => {
  const dispatch = useDispatch();
  const userData = useSelector((state: State) => state.auth.userData);
  const notAvailable = () => {
    dispatch(setInfoMessage(["Ta operacja będzie dostępna wkrótce"]));
  };
  return (
    <div className={"panel-account-data"}>
      <h3>
        Cześć, {userData.firstName} {userData.lastName}
      </h3>
      <fieldset className={"panel-account-settings"}>
        <legend>Ustawienia konta</legend>
        <AccountData />
        <ChangePassword />
        <button className={"setting-button"} onClick={() => notAvailable()}>
          Zrezygnuj z newslettera
        </button>
        <button className={"setting-button"} onClick={() => notAvailable()}>
          Usuń konto
        </button>
        <button className={"setting-button"} onClick={() => dispatch(logOut())}>
          Wyloguj
        </button>
      </fieldset>

      <div className={"panel-account-btn-tickets"}>
        <span>Poniżej przyciski dotyczące Twoich zakupów.</span>
        <button
          className={`tickets-button ${ticketsTabActive === 0 ? "tickets-btn-active" : ""}`}
          onClick={() => setTicketsTabActive(0)}
        >
          Twoje bilety
        </button>
        <button
          className={`tickets-button ${ticketsTabActive === 1 ? "tickets-btn-active" : ""}`}
          onClick={() => setTicketsTabActive(1)}
        >
          Twoje rezerwacje
        </button>
      </div>
    </div>
  );
};

export default AccountDataPanel;
